import { motion } from 'framer-motion';
import { User } from 'lucide-react';
import { useRecoilValue } from 'recoil';
import { userProfileData } from '../RecoilAtom';
import { RainLogo } from './RainLogo';

export const ChatBubble = ({ type, children, className, onClick }) => {
  const isAI = type === 'ai';
  const userProfile = useRecoilValue(userProfileData);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{
        type: 'spring',
        stiffness: 350,
        damping: 25
      }}
      className={`gm-bubble-row ${isAI ? 'gm-bubble-row--ai' : 'gm-bubble-row--user'} ${className || ''}`}
    >
      {isAI && (
        <motion.div
          className="gm-bubble-avatar"
          initial={{ scale: 0, rotate: -180 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{ type: 'spring', delay: 0.1 }}
        >
          <RainLogo size={36} animate={false} />
        </motion.div>
      )}

      <motion.div
        className={`gm-bubble ${isAI ? 'gm-bubble--ai' : 'gm-bubble--user'} ${onClick ? 'gm-bubble--clickable' : ''}`}
        whileHover={{ scale: 1.005 }}
        transition={{ type: 'spring', stiffness: 400 }}
        onClick={onClick}
      >
        {isAI && (
          <div className="gm-bubble-gradient" />
        )}

        <div className="gm-bubble-content">
          {children}
        </div>
      </motion.div>

      {!isAI && (
        <motion.div
          className="gm-bubble-avatar-user"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: 'spring', delay: 0.1 }}
        >
          {userProfile?.profilePic ? (
            <img
              src={userProfile.profilePic}
              alt="user"
              className="gm-bubble-avatar-img"
            />
          ) : (
            <User className="gm-icon-md gm-text-foreground" />
          )}
        </motion.div>
      )}
    </motion.div>
  );
};

export const TypingIndicator = () => (
  <motion.div
    initial={{ opacity: 0, y: 20, scale: 0.95 }}
    animate={{ opacity: 1, y: 0, scale: 1 }}
    exit={{ opacity: 0, y: -10, scale: 0.95 }}
    className="gm-typing-row"
  >
    <motion.div
      className="gm-bubble-avatar"
    >
      <motion.div
        animate={{ scale: [1, 1.1, 1] }}
        transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
      >
        <RainLogo size={36} animate={false} />
      </motion.div>
    </motion.div>

    <motion.div
      className="gm-typing-bubble"
    >
      {[0, 1, 2].map((i) => (
        <motion.span
          key={i}
          className="gm-typing-dot"
          animate={{
            y: [-1, -6, -1],
            opacity: [0.4, 1, 0.4]
          }}
          transition={{
            duration: 0.7,
            repeat: Infinity,
            delay: i * 0.12,
            ease: "easeInOut"
          }}
        />
      ))}
    </motion.div>
  </motion.div>
);
